<!-- 文字滚动组件 -->
<template>
  <div class="animate_wrapper" ref="wrapper">
    <div class="animate-box" ref="animateBox" :style="contentStyle">
      <span class="animate" ref='marquee'>
        <span class="item" v-for="(item, index) in messageList" :key="index">
          {{ item}}
        </span>
      </span>
      <span class="animate" ref="mqrqueeCopy">
        <span class="item" v-for="(item, index) in messageList" :key="index">
          {{ item}}
        </span>
      </span>
    </div>

  </div>
</template>
  
<script>
export default {
  name: 'message-scroll',
  data() {
    return {
      messageList: [
        // "1滚动信23434息滚动34信息",
        // "1滚动信23434息滚动34信息息滚动34信息",
        // "1滚动信23434息滚动34信息",
        // "4656滚动信454息464565滚动4545信息滚动4545信息滚动454信息滚动信息",
      ],
      contentStyle: {
        transitionDuration: '0s',
        transform: 'translateX(0px)'
      },

      timer: null,
    }
  },
  mounted() {
    this.getMessageList();
  },
  methods: {
    getMessageList() {
      var that = this;
      this.loading = true;
      $.ajax({
        url: "//common.newcomment.cntv.cn/data/list",
        dataType: "jsonp",
        data: {
          app: "cctvdhd",
          itemid: "2024cibexpo",
          page: 1,
          prepage: 30
        },
        jsonp: "jsonp_callback",
        // jsonpCallback: "2024cibexpo",
        cache: true,
        error: function () {
          console.log("error");
        },
        success: function (data) {
          if (data.code == 0) {
            that.messageList = data.data.content.map(item => item.message);
            that.$nextTick(() => {
              that.startAnimate()
            })
          }
        },
      });
    },

    startAnimate() {
      let that = this;
      let wrapper = that.$refs.wrapper;
      let animateBox = that.$refs.animateBox;
      let wrapperWidth = wrapper.getBoundingClientRect().width;
      let marquee = that.$refs.marquee;

      // let marqueeContent = this.$refs.marqueeContent;
      let contentWidth = marquee.getBoundingClientRect().width;
      let distance = 0;

      that.timer = setInterval(() => {
        //当文字移动超出wrapper的左侧时 则归位
    
        if (contentWidth < -distance) {
          distance = 0;
        }
        distance--;
        that.$refs.animateBox.style.transform = 'translateX(' + distance + 'px)  scale(1)';
      }, 20);


    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
}
</script>
<style lang="scss" scoped>
@mixin background-com {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.animate_wrapper {
  position: absolute;
  left: 84px;
  right: 84px;
  bottom: 20px;
  height: 30px;
  white-space: nowrap;
  overflow: hidden;
  font-size: 14px;
  line-height: 25px;
  background-color: #990000;
  color: #fff;
  border-radius: 10px;
  padding: 2px 0px;
}

.animate-box {
  height: 100%;
  white-space: nowrap;
  transition-timing-function: linear;
}

.animate {
  display: inline-block;
  margin-left: 8px;
  white-space: nowrap;
  transition-timing-function: linear;
  // animation: wordsLoop 70s linear infinite normal;
}

.item {
  margin-right: 80px;
}

@keyframes wordsLoop {
  0% {
    transform: translateX(20%);
  }

  100% {
    transform: translateX(-100%);
  }
}
</style>